/* MT/26 helpers: hero navigation, pause controls for moving content, accessible names, frame titles, cart status announcements. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pauseButton(pauseLabel, playLabel, onChange) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mt-a11y-pause';
    b.innerHTML = '<span aria-hidden="true"></span>';
    function set(paused) {
      b.setAttribute('aria-pressed', paused ? 'true' : 'false');
      b.setAttribute('aria-label', paused ? playLabel : pauseLabel);
      onChange(paused);
    }
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      set(b.getAttribute('aria-pressed') !== 'true');
    });
    b.mtSet = set;
    return b;
  }
  window.MT = window.MT || {};
  window.MT.pauseButton = pauseButton;

  /* accessible name must contain the visible text (WCAG 2.5.3) */
  function fixCards() {
    document.querySelectorAll('.mt-card__media[aria-label]').forEach(function (a) {
      if (a.dataset.mtNamed) return;
      var txt = (a.innerText || '').split(/[ \n\t]+/).join(' ').trim();
      if (txt) a.setAttribute('aria-label', a.getAttribute('aria-label') + ', ' + txt);
      a.dataset.mtNamed = '1';
    });
  }

  /* every frame needs a title (WCAG 4.1.2) */
  function fixFrames() {
    document.querySelectorAll('iframe:not([title])').forEach(function (f) {
      var r = f.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) {
        f.setAttribute('title', 'Hidden frame');
        f.setAttribute('aria-hidden', 'true');
        f.setAttribute('tabindex', '-1');
      } else {
        f.setAttribute('title', 'Embedded content');
      }
    });
  }

  function init() {
    /* announcement marquee */
    document.querySelectorAll('.mt-marquee').forEach(function (m) {
      if (m.querySelector('.mt-a11y-pause')) return;
      var b = pauseButton('Pause announcements', 'Play announcements', function (p) {
        m.classList.toggle('mt-is-paused', p);
      });
      m.appendChild(b);
      b.mtSet(reduce);
    });

    document.querySelectorAll('.mt-hero').forEach(function (h) {
      var dots = h.querySelectorAll('.mt-hero__dot');
      if (dots.length < 2) return;

      /* arrows and swipe */
      if (!h.querySelector('.mt-hero__arrow')) {
        var go = function (dir) {
          var cur = 0;
          dots.forEach(function (d, k) { if (d.classList.contains('mt-active')) cur = k; });
          dots[(cur + dir + dots.length) % dots.length].click();
        };
        [['prev', -1, 'Previous slide', 'M15 6l-6 6 6 6'], ['next', 1, 'Next slide', 'M9 6l6 6-6 6']].forEach(function (a) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'mt-hero__arrow mt-hero__arrow--' + a[0];
          b.setAttribute('aria-label', a[2]);
          b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + a[3] + '"/></svg>';
          b.addEventListener('click', function () { go(a[1]); });
          h.appendChild(b);
        });
        var x0 = null, y0 = null;
        h.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        h.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1);
        }, { passive: true });
      }

      /* pause control for autoplay */
      if (!(parseInt(h.dataset.autoplay || '0', 10) > 0) || h.querySelector('.mt-a11y-pause')) return;
      var paused = false;
      h.addEventListener('mouseleave', function (e) { if (paused) e.stopImmediatePropagation(); }, true);
      h.addEventListener('click', function () {
        if (paused) setTimeout(function () { h.dispatchEvent(new Event('mouseenter')); }, 0);
      });
      var pb = pauseButton('Pause slideshow', 'Play slideshow', function (p) {
        paused = p;
        h.dataset.mtPaused = p ? '1' : '';   /* mt-base.js: play() stays off while the button is pressed */
        h.dispatchEvent(new Event(p ? 'mouseenter' : 'mouseleave'));
      });
      pb.classList.add('mt-a11y-pause--hero');
      h.appendChild(pb);
      if (reduce) { pb.mtSet(true); } else { pb.setAttribute('aria-pressed', 'false'); pb.setAttribute('aria-label', 'Pause slideshow'); }
    });

    /* cart button: name includes the visible count */
    var count = document.querySelector('[data-mt-cart-count]');
    if (count) {
      var cartBtn = count.closest('a, button');
      var setCart = function () {
        var n = parseInt(count.textContent, 10) || 0;
        if (cartBtn) cartBtn.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
      };
      setCart();
      new MutationObserver(setCart).observe(count, { childList: true, characterData: true, subtree: true });
    }

    fixCards();
    fixFrames();
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { fixCards(); fixFrames(); }, 400);
    }).observe(document.body, { childList: true, subtree: true });

    /* status messages for screen readers */
    var live = document.createElement('div');
    live.className = 'visually-hidden';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    document.body.appendChild(live);
    var last = 0;
    function announce(msg) {
      var now = Date.now();
      if (now - last < 1500) return;
      last = now;
      live.textContent = '';
      setTimeout(function () { live.textContent = msg; }, 60);
    }
    document.addEventListener('on:cart:add', function () { announce('Item added to cart'); });
    document.addEventListener('mt:announce', function (e) { if (e.detail) announce(String(e.detail)); });   /* other scripts: filter result counts etc. (WCAG 4.1.3) */
    var nativeFetch = window.fetch;
    if (nativeFetch) {
      window.fetch = function () {
        var u = (arguments[0] && arguments[0].url) || arguments[0] || '';
        var r = nativeFetch.apply(this, arguments);
        if (typeof u === 'string' && u.indexOf('/cart/add') !== -1) {
          r.then(function (res) { if (res && res.ok) announce('Item added to cart'); }).catch(function () {});
        }
        return r;
      };
    }
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();